export default function resizeImageCanvas(imgSec, callback) {
  
function resizeNow(imgSec) {
    const img = imgSec.getImage();

    // Try style size first (OL icon)
    let size = imgSec.getSize();

    // If no explicit size → use natural size
    if (!size || size[0] === 0 || size[1] === 0) {
        size = [img.naturalWidth || img.width, img.naturalHeight || img.height];
    }

    const [width, height] = size;

    if (!width || !height) return null; // cannot draw

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);

    return canvas;
}

    const img = imgSec.getImage();

    // If image not loaded → wait for it
    if (!img.complete || img.naturalWidth === 0) {
        img.onload = () => callback(resizeNow(imgSec));
        img.onerror = () => callback(null);  // fail-safe
        return;
    }

    // Already loaded
    callback(resizeNow(imgSec));
}
